/**
 * Мок отчётов по клиникам: платформенный свод (4 клиники из MOCK_CLIENTS)
 * и детали. Детали статичны для любой клиники — на живом их считает BE.
 */

import type {
  ClinicReportSummary,
  ClinicsReport,
  DoctorReportRow,
  RevenuePoint,
  ServiceReportRow,
} from './types';

export const MOCK_CLINICS_REPORT: ClinicsReport = {
  dateFrom: null,
  dateTo: '2026-08-11',
  totalRevenueNet: 1_695_000,
  totalDebt: 84_500,
  rows: [
    {
      clinicId: 'c-1',
      name: 'Дентал Плюс',
      cityName: 'Бишкек',
      revenueNet: 612_000,
      debt: 32_500,
      appointments: 428,
      completed: 391,
      doctors: 7,
      patients: 246,
    },
    {
      clinicId: 'c-3',
      name: 'Ак-Тиш',
      cityName: 'Бишкек',
      revenueNet: 540_000,
      debt: 18_000,
      appointments: 385,
      completed: 361,
      doctors: 12,
      patients: 214,
    },
    {
      clinicId: 'c-5',
      name: 'Смайл Студия',
      cityName: 'Джалал-Абад',
      revenueNet: 331_000,
      debt: 21_400,
      appointments: 246,
      completed: 218,
      doctors: 4,
      patients: 132,
    },
    {
      clinicId: 'c-10',
      name: 'Медстом Центр',
      cityName: 'Бишкек',
      revenueNet: 212_000,
      debt: 12_600,
      appointments: 174,
      completed: 158,
      doctors: 15,
      patients: 98,
    },
  ],
};

export const MOCK_CLINIC_SUMMARY: ClinicReportSummary = {
  revenue: {income: 648_500, refund: 36_500, net: 612_000},
  appointments: {total: 428, completed: 391, cancelled: 24, noShow: 13},
  patients: {total: 246, new: 58, returning: 188},
  charged: 644_500,
  discounts: 41_200,
  debt: 32_500,
  averageCheck: 1_648,
};

export const MOCK_REVENUE_POINTS: RevenuePoint[] = [
  {bucket: '2026-03-01', income: 84_000, refund: 6_000, net: 78_000},
  {bucket: '2026-04-01', income: 96_500, refund: 4_500, net: 92_000},
  {bucket: '2026-05-01', income: 101_000, refund: 8_000, net: 93_000},
  {bucket: '2026-06-01', income: 112_000, refund: 5_000, net: 107_000},
  {bucket: '2026-07-01', income: 124_000, refund: 7_000, net: 117_000},
  {bucket: '2026-08-01', income: 131_000, refund: 6_000, net: 125_000},
];

export const MOCK_DOCTOR_ROWS: DoctorReportRow[] = [
  {
    membershipId: 'd-1',
    fullName: 'Осмонова Динара',
    specializationName: 'Терапевт',
    appointments: 118,
    completed: 109,
    cancelled: 6,
    charged: 186_000,
    paid: 172_000,
    debt: 14_000,
    averageCheck: 1_706,
  },
  {
    membershipId: 'd-2',
    fullName: 'Асанов Бакыт',
    specializationName: 'Ортопед',
    appointments: 102,
    completed: 94,
    cancelled: 5,
    charged: 168_500,
    paid: 158_000,
    debt: 10_500,
    averageCheck: 1_793,
  },
  {
    membershipId: 'd-3',
    fullName: 'Керимова Нургуль',
    specializationName: 'Хирург',
    appointments: 86,
    completed: 79,
    cancelled: 4,
    charged: 154_000,
    paid: 149_000,
    debt: 5_000,
    averageCheck: 1_949,
  },
  {
    membershipId: 'd-4',
    fullName: 'Мамытов Эрлан',
    specializationName: 'Ортодонт',
    appointments: 74,
    completed: 66,
    cancelled: 6,
    charged: 136_000,
    paid: 133_000,
    debt: 3_000,
    averageCheck: 2_061,
  },
];

export const MOCK_SERVICE_ROWS: ServiceReportRow[] = [
  {serviceId: 's-1', name: 'Лечение кариеса', count: 142, revenue: 198_800},
  {serviceId: 's-2', name: 'Профгигиена', count: 96, revenue: 124_800},
  {serviceId: 's-3', name: 'Удаление зуба', count: 54, revenue: 97_200},
  {serviceId: 's-4', name: 'Протезирование', count: 21, revenue: 88_100},
  {serviceId: 's-5', name: 'Лечение пульпита', count: 33, revenue: 72_600},
  {serviceId: null, name: 'Без услуги', count: 18, revenue: 30_500},
];
